// import api from "../../api/api";
// import VueCookies from "vue-cookies";

// initial users state
const state = {
  token: undefined,
};

// getters
const getters = {
  getState: (state) => state,
};

// actions
const actions = {
  setToken: async ({ commit }, payload) => {
    await commit('setToken', payload.value);
  },
  removeToken: async ({ commit }) => {
    await commit('removeToken');
  },
};

// mutations
const mutations = {
  setToken(state, payload) {
    state.token = payload;
    localStorage.setItem('token', payload);
    // api.defaults.headers.Authorization = "Bearer " + payload;
    /* VueCookies.set(
      "token",
      "Bearer " + payload,
      null,
      null,
      process.env.VUE_APP_DOMAIN
    ); */
  },
  removeToken(state) {
    state.token = undefined;
    localStorage.removeItem('token');
    // delete api.defaults.headers.Authorization;
    // VueCookies.remove("token", null, process.env.VUE_APP_DOMAIN);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
